export default __webpack_public_path__ + "static/media/click_no_componenete.fc914445.png";